// import React, { createContext, useState, useContext } from "react";

// const LoaderContext = createContext();

// export const LoaderProvider = ({ children }) => {
//   const [loading, setLoading] = useState(false);

//   const showLoader = () => setLoading(true);
//   const hideLoader = () => setLoading(false);

//   return (
//     <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
//       {/* Internal CSS for loader */}
//       <style>
//         {`
//           .loader-overlay {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background-color: rgba(255, 255, 255, 0.8);
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             z-index: 2000;
//           }

//           .spinner {
//             width: 60px;
//             height: 60px;
//             border: 6px solid #e0e0e0;
//             border-top: 6px solid #007bff;
//             border-radius: 50%;
//             animation: spin 1s linear infinite;
//           }

//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//       </style>

//       {loading && (
//         <div className="loader-overlay">
//           <div className="spinner"></div>
//         </div>
//       )}
//       {children}
//     </LoaderContext.Provider>
//   );
// };

// export const useLoader = () => useContext(LoaderContext);


















import React, { createContext, useState, useContext } from "react";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const showLoader = () => {
    setFadeOut(false);
    setLoading(true);
  };

  const hideLoader = () => {
    setFadeOut(true);

    setTimeout(() => {
      setLoading(false);
      setFadeOut(false); // reset for next use
    }, 500);
  };

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader, loading }}>
      {/* Loader Styles */}
      <style>{`
        .loader-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          transition: opacity 0.4s ease;
          font-family: Arial, sans-serif;
        }

        .loader-overlay.fade-out {
          opacity: 0;
          pointer-events: none;
        }

        .netflix-loader {
          text-align: center;
        }

        .loading-text {
          font-size: 2rem;
          font-weight: 900;
          letter-spacing: 6px;
          margin-bottom: 30px;
        }

        .loading-letter {
          display: inline-block;
          opacity: 0;
          transform: translateY(30px);
          animation: letterAnim 0.8s ease forwards;
          color: #e50914;
        }

        .loading-letter:nth-child(n) {
          animation-delay: calc(var(--i) * 0.1s);
        }

        @keyframes letterAnim {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        .bar {
          width: 280px;
          height: 4px;
          background: rgba(255,255,255,0.2);
          overflow: hidden;
          margin: 0 auto;
        }

        .progress {
          width: 40%;
          height: 100%;
          background: linear-gradient(90deg,#e50914,#ff6b6b);
          animation: progress 1.8s infinite;
        }

        @keyframes progress {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(250%); }
        }

        .subtext {
          margin-top: 20px;
          color: #aaa;
          font-size: 14px;
        }
      `}</style>

      {loading && (
        <div className={`loader-overlay ${fadeOut ? "fade-out" : ""}`}>
          <div className="netflix-loader">
            <div className="loading-text">
              {"MAAMAAS".split("").map((l, i) => (
                <span
                  key={i}
                  className="loading-letter"
                  style={{ "--i": i }}
                >
                  {l}
                </span>
              ))}
            </div>

            <div className="bar">
              <div className="progress"></div>
            </div>

            <div className="subtext">
              Preparing your experience...
            </div>
          </div>
        </div>
      )}

      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
